import gql from "graphql-tag";
import { QueryHookOptions } from "react-apollo";
import { useRefetchableQuery } from "core/hooks/useRefetchableQuery";
import {
  GetTasksTotal as GetTasksTotalGenerated,
  GetTasksTotalVariables as GetTasksTotalVariablesGenerated,
} from "core/queries/__generated__/GetTasksTotal";

// Queries
export interface GetTasksTotalResponse extends GetTasksTotalGenerated {}
export interface GetTasksTotalVariables
  extends GetTasksTotalVariablesGenerated {}
export const getTasksTotal = gql`
  query GetTasksTotal($filter: TaskFilterInput!) {
    tomTasksCount(filter: $filter)
  }
`;

export const useRefetchableGetTasksTotalQuery = (
  options: QueryHookOptions<GetTasksTotalResponse, GetTasksTotalVariables>,
) =>
  useRefetchableQuery<GetTasksTotalResponse, GetTasksTotalVariables>(
    getTasksTotal,
    {
      ...options,
    },
  );
